// extracted by mini-css-extract-plugin
export var container = "_64-0";
export var fallback = "_64-5";
export var fallbackIcon = "_64-6";
export var hidden = "_64-2";
export var image = "_64-3";
export var loaded = "_64-4";
export var placeholder = "_64-1";